import { Pagination } from "@nexus/ui";
import { useEffect, useState } from "react";

import type { DashboardRecord } from "@/lib/dashboard/types";
import {
  DashboardTable,
  type DashboardTableProps,
} from "@/pages/workspace/components/DashboardTable";

const PAGE_SIZE = 10;

interface DashboardResultsProps extends Omit<DashboardTableProps, "dashboards"> {
  dashboards: readonly DashboardRecord[];
}

/** One table, one header and one pagination control for the selected search scope. */
export function DashboardResults({ dashboards, ...tableProps }: DashboardResultsProps) {
  const [page, setPage] = useState(1);
  const ids = dashboards.map((item) => item.id).join("|");
  useEffect(() => setPage(1), [ids]);
  const pageCount = Math.max(1, Math.ceil(dashboards.length / PAGE_SIZE));
  const currentPage = Math.min(page, pageCount);
  const first = (currentPage - 1) * PAGE_SIZE;

  return (
    <section aria-label="Dashboard results">
      <DashboardTable
        {...tableProps}
        presentation="catalog"
        dashboards={dashboards.slice(first, first + PAGE_SIZE)}
      />
      <Pagination
        label="Dashboard pages"
        page={currentPage}
        pageCount={pageCount}
        onPageChange={setPage}
        className="mt-3"
        summary={`${first + 1}–${Math.min(first + PAGE_SIZE, dashboards.length)} of ${dashboards.length}`}
      />
    </section>
  );
}
